




<template>
    <a :href="target" ref='topnotification' v-view="viewHandler" class="relative w-full left-0 bg-primary text-white z-50 flex items-center sm:justify-center text-sm uppercase overflow-hidden border-2  border-primary hover:border-white dark:hover:border-neutral-900 cursor-pointer transition duration-300"
        :class="[show ? 'h-12 sm:h-8' : 'h-0 transition-all duration-500']">
        <div class="scroll flex sm:block">
            <p v-for="n in 10" :class="[n != 1 ? 'sm:hidden' : '']">
                {{ message }}
            </p>
        </div>
    </a>
</template>


<script>

export default {
    data() {
        return {
            status: this.$attrs.status ?? 'error',
            duration: this.$attrs.duration ?? null,
            message : this.$attrs.message ?? 'Something went wrong',
            target: this.$attrs.target ?? '',
            show: false,
        }
    },
    methods: {
        viewHandler(e) {
            if (this.duration == null) {
                if (e.percentInView > 0) {
                    document.querySelector('meta[name="theme-color"][media="(prefers-color-scheme: light)"]').setAttribute("content", this.$main_color);
                    document.querySelector('meta[name="theme-color"][media="(prefers-color-scheme: dark)"]').setAttribute("content", this.$main_color_darkmode);
                } else {
                    document.querySelector('meta[name="theme-color"][media="(prefers-color-scheme: light)"]').setAttribute("content", '#ffffff');
                    document.querySelector('meta[name="theme-color"][media="(prefers-color-scheme: dark)"]').setAttribute("content", '#171717');
                }
            }
        }
    },
    mounted() {
        if (this.duration != null) {
            this.$refs.topnotification.classList.add('transition-all')
            this.$refs.topnotification.classList.add('duration-500')
            this.show = true
            setTimeout(() => this.show = false, this.duration);
        } else {
            this.show=true;
            document.querySelector('meta[name="theme-color"][media="(prefers-color-scheme: light)"]').setAttribute("content", this.$main_color);
            document.querySelector('meta[name="theme-color"][media="(prefers-color-scheme: dark)"]').setAttribute("content", this.$main_color_darkmode);
        }
    }
}
</script>

